import { SpinnerIcon } from './svg'

const AppLoading = () => (
  <div className="flex h-screen">
    <div className='h-screen w-screen absolute flex items-center justify-center'>
      <SpinnerIcon />
    </div>
  </div>
)

export default AppLoading
